import React, { useEffect } from 'react'
import Navbar from './Navbar/navbar'
import Sidebar from './Sidebar/sidebar'
import TopMenu from './TopMenu/topMenu'
import "./index.css"
import i18next from 'src/i18n'
import useAuth from 'src/hooks/useAuth'

const Index = ({ children }) => {
    const { languageToggler } = useAuth()

    useEffect(() => {
        const language = localStorage.getItem("lang")
        if (!language) return localStorage.setItem('lang', "en")
        i18next.changeLanguage(language)
    }, [languageToggler])

    return (
        <>
            <TopMenu />
            <Navbar />
            <div className='wrapper'>
                <Sidebar />
                <div id="content">
                    {children}
                </div>
            </div>
        </>
    )
}

export default Index